import React, { Component } from 'react';
//  Components
import Header from '../components/Header/header';

class AvisoPrivacidad extends Component {
   render() {
      return (
         <div className="flex">
            <div className="column">
               <Header inicio={true}></Header>
               <div className="privacidad justify-center">
                  <div className="container">
                     <div className="column">
                        <div className="white-space-48"></div>
                        <h2 className="color-secondary quicksand">
                           AVISO DE PRIVACIDAD
                        </h2>
                        <div className="white-space-24"></div>
                        <p className="text-justify">
                           Expomedica (Adriana Zenteno Gómez), con domicilio en
                           Av. Coba lt.25-1, Mz. 13, Sm 22 Local 102 y 103,
                           Cancún, Q, Roo es el responsable del tratamiento de
                           los datos personales que nos proporcione, los cuales
                           serán protegidos conforme a lo dispuesto por la Ley
                           316 de Protección de Datos Personales en Posesión de
                           Sujetos Obligados para el Estado de Cancún Q. Roo, y
                           demás normatividad que resulte aplicable.
                        </p>
                        <div className="white-space-8"></div>
                        <p className="text-justify">
                           Los datos personales que recabamos de usted, los
                           utilizaremos para las siguientes finalidades:
                        </p>
                        <div className="white-space-8"></div>
                        <ul>
                           <li>
                              Para la elaboración de facturas, contratos y
                              órdenes de compra que respalde los productos
                              comprados.
                           </li>
                        </ul>
                        <div className="white-space-8"></div>
                        <p className="text-justify">
                           De manera adicional, podríamos utilizar su
                           información personal para las siguientes finalidades
                           que no son necesarias para el servicio solicitado,
                           pero que nos permiten y facilitan brindarle una mejor
                           atención:
                        </p>
                        <div className="white-space-8"></div>
                        <p className="text-justify">
                           Informarle sobre lanzamientos de nuevos productos,
                           cambios de precios, promociones, entre otros.
                        </p>
                        <div className="white-space-8"></div>
                        <p className="text-justify">
                           En caso de que no desee que sus datos personales sean
                           tratados para estos fines adicionales, este usted
                           puede manifestarlo al siguiente correo electrónico:
                           administración.exm@expomedica.mx; comunicándose a los
                           teléfonos 998-350-95-62, 998-887-95-09 o bien por
                           presentando escrito en el domicilio ubicado Av. Coba
                           lt.25-1, Mz. 13, Sm 22 Local 102 y 103, Cancún, Q,
                           Roo.
                        </p>
                        <div className="white-space-8"></div>
                        <p className="text-justify">
                           Para llevar a cabo las finalidades antes señaladas en
                           el presente aviso de privacidad, se recabaran datos
                           sensibles (datos personales):
                        </p>
                        <div className="white-space-8"></div>
                        <ul>
                           <li>Nombre</li>
                           <li>Domicilio</li>
                           <li>Registro Federal de Contribuyentes (RFC)</li>
                           <li>Clave Única de Registro de Población (CURP)</li>
                           <li>Lugar y fecha de nacimiento</li>
                           <li>Nacionalidad</li>
                           <li>Datos bancarios</li>
                           <li>Entre otros</li>
                        </ul>
                        <div className="white-space-8"></div>
                        <p className="text-justify">
                           Le informamos que sus datos personales no son
                           compartidos con otras empresas y son única y
                           exclusivamente para los fines señalados líneas
                           arriba.
                        </p>
                        <div className="white-space-8"></div>
                        <p className="text-justify">
                           Usted tiene derecho a conocer qué datos personales
                           tenemos de usted, para qué los utilizamos y las
                           condiciones del uso que les damos (Acceso). Asimismo,
                           es su derecho solicitar la corrección de su
                           información personal en caso de que esté
                           desactualizada, sea inexacta o incompleta
                           (Rectificación); que la eliminemos de nuestros
                           registros o bases de datos cuando considere que la
                           misma no está siendo utilizada conforme a los
                           principios, deberes y obligaciones previstas en la
                           normativa (Cancelación); así como oponerse al uso de
                           sus datos personales para fines específicos
                           (Oposición). Estos derechos se conocen como derechos
                           ARCO.
                        </p>
                        <div className="white-space-8"></div>
                        <p className="text-justify">
                           Para el ejercicio de cualquiera de los derechos ARCO,
                           usted deberá presentar la solicitud respectiva en el
                           siguiente correo electrónico:
                           administración.exm@expomedica.mx.; comunicándose al
                           teléfono 998-887-95-09; la que deberá contener:
                        </p>
                        <div className="white-space-8"></div>
                        <ol>
                           <li>
                              El nombre del titular y su domicilio o cualquier
                              otro medio para recibir notificaciones.
                           </li>
                           <li>
                              Los documentos que acrediten la identidad del
                              titular, y en su caso, la personalidad e identidad
                              de su representante.
                           </li>
                           <li>
                              De ser posible, el área responsable que trata los
                              datos personales.
                           </li>
                           <li>
                              La descripción clara y precisa de los datos
                              personales respecto de los que se busca ejercer
                              alguno de los derechos de ARCO, salvo que se trate
                              del derecho de acceso.
                           </li>
                           <li>
                              La descripción del derecho ARCO que se pretende
                              ejercer, o bien, lo que solicite el titular.
                           </li>
                           <li>
                              Cualquier otro elemento o documento que facilite
                              la localización de los datos personales, en su
                              caso.
                           </li>
                        </ol>
                        <div className="white-space-8"></div>
                        <p className="text-justify">
                           Para conocer el procedimiento y requisitos para el
                           ejercicio de los derechos ARCO, usted podrá llamar a
                           los siguiente número telefónico 998-887-95-09; o bien
                           por presentando por escrito en el domicilio ubicado
                           en Av. Coba lt.25-1, Mz. 13, Sm 22 Local 102 y 103,
                           Cancún, Q, Roo en donde se dará trámite a las
                           solicitudes para el ejercicio de estos derechos, y se
                           atenderá cualquier duda que pudiera tener respecto al
                           tratamiento de su información.
                        </p>
                        <div className="white-space-8"></div>
                        <p className="text-justify">
                           Usted puede revocar el consentimiento que, en su
                           caso, nos haya otorgado para el tratamiento de sus
                           datos personales. Sin embargo, es importante que
                           tenga en cuenta que no en todos los casos podremos
                           atender su solicitud o concluir el uso de forma
                           inmediata, ya que es posible que por alguna
                           obligación legal requiramos seguir tratando sus datos
                           personales. Asimismo, usted deberá considerar que
                           para ciertos fines, la revocación de su
                           consentimiento implicará que no le podamos seguir
                           prestando el servicio que nos solicitó, o la
                           conclusión de su relación con nosotros.
                        </p>
                        <div className="white-space-8"></div>
                        <p className="text-justify">
                           El presente aviso de privacidad puede sufrir
                           modificaciones, cambios o actualizaciones derivadas
                           de nuevos requerimientos legales; de nuestras propias
                           necesidades por los productos o servicios que
                           ofrecemos; de nuestras prácticas de privacidad; de
                           cambios en nuestro modelo de negocio, o por otras
                           causas.
                        </p>
                        <div className="white-space-8"></div>
                        <p className="text-justify">
                           Nos comprometemos a mantenerlo informado sobre los
                           cambios que pueda sufrir el presente aviso de
                           privacidad, a través del correo electrónico que nos
                           proporcione.
                        </p>
                        <div className="white-space-8"></div>
                        <p className="text-justify">
                           Última actualización <strong>SEPTIEMBRE 2019</strong>
                        </p>
                        <div className="white-space-48"></div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      );
   }
}

export default AvisoPrivacidad;



// WEBPACK FOOTER //
// ./src/pages/aviso-privacidad.js